module.exports = __webpack_public_path__ + "static/media/charpy.231d576f.png";